import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Form } from 'common/components';

const CompanyActions = ({
  companyId,
  isLoading,
  canEdit,
  canToggle, // canToggle is the result of is root
  handleToggle = () => {},
  isActive,
  t = (key) => key,
}) => {
  return canEdit || canToggle ? (
    <div className="text-right mt-4">
      {canToggle && (
        <Form.Button
          type={'button'}
          color={isActive ? 'secondary' : 'secondary'}
          extraClassName="btn-sm mr-2"
          text={t(isActive ? 'actions.deactivate' : 'actions.activate')}
          isLoading={isLoading}
          onClick={handleToggle}
        />
      )}
      {canEdit && (
        <Form.Link
          to={`/companies/${companyId}/edit`}
          className={classnames('btn btn-primary btn-sm mr-2', {
            disabled: isLoading,
          })}
        >
          {t('actions.edit')}
        </Form.Link>
      )}
      {canToggle && (
        <Form.Link
          to={`/companies/${companyId}/edit_root`}
          className={classnames('btn btn-primary btn-sm', {
            disabled: isLoading,
          })}
        >
          {t('actions.editRoot')}
        </Form.Link>
      )}
    </div>
  ) : null;
};

CompanyActions.propTypes = {
  companyId: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canToggle: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default CompanyActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyActions.js